import React from 'react';
import { useFormikContext } from 'formik';
import { FormHelperText } from '@mui/material';

const DealFormMessages = () => {
	const { values } = useFormikContext();
	return (
		<>
			{values.errorMessage.length > 0 && (
				<FormHelperText sx={{ padding: '1em' }} error>
					{values.errorMessage}
				</FormHelperText>
			)}
			{values.successMessage.length > 0 && (
				<FormHelperText
					sx={{
						color: 'green',
						padding: '1em',
					}}
				>
					{values.successMessage}
				</FormHelperText>
			)}
		</>
	);
};
export default DealFormMessages;
